import { Component,OnInit,OnDestroy,AfterViewInit } from "@angular/core";
import { takeWhile } from "rxjs/operators";

import {
    FvmsApiDtgInstallService
} from "src/app/shared/service";

@Component({
    templateUrl: "./install.main.component.html"
})
export class InstallMainComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    searchKey:string = "";
    listItem:any[];

    constructor(
        private fvmsApiDtgInstallService:FvmsApiDtgInstallService
    ) { }

    ngOnInit() {
        
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {}

    clickSearch(){
        if(!this.searchKey || this.searchKey.length < 2){
            return;
        }
        this.fvmsApiDtgInstallService.getInstallStatusList(this.searchKey)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    if(apiResponse.resultValue){
                        // console.log("clickSearch",apiResponse.resultValue);
                        this.listItem = apiResponse.resultValue;
                    }else{
                        this.listItem = null;
                    }
                }else{
                    this.listItem = null;
                }
            },err => {
                this.listItem = null;
                console.error(err);
            });
    }
}